import Vue from 'vue'
import Router from 'vue-router'
import store from './store';

/* const authGuard = (to, from, next) => {
  if (store.getters['authenticationService/user']) {
    next();
  } else {
    store.dispatch('authenticationService/signOut');

    next('/pages/login');
  }
};
 */
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/pages',
      component: () => import('@/views/pages/Index'),
      children: [
       /*  {
          name: 'Lock',
          path: 'lock',
          component: () => import('@/views/pages/Lock'),
        }, */
        {
          name: 'Login',
          path: 'login',
          component: () => import('@/views/pages/Login'),
        },
        /* {
          name: 'Pricing',
          path: 'pricing',
          component: () => import('@/views/pages/Pricing'),
        }, */
        {
          name: 'Register',
          path: 'register',
          component: () => import('@/views/pages/Register'),
        },
        {
          name: 'ResetPassword',
          path: 'resetpassword',
          component: () => import('@/views/pages/ResetPassword'),
        },
      ],
    },
    {
      path: '/user',
      component: () => import('@/views/user/Index'),
      meta: { requiresAuth: true },
      children: [
        {
          name: 'User Profile',
          path: '',
          component: () => import('@/views/user/Profile'),
          meta: { requiresAuth: true }
        },
        {
          name: 'User Settings',
          path: 'settings',
          component: () => import('@/views/user/Settings'),
          meta: { requiresAuth: true }
        },
      ],
    },
    {
      path: '/parent',
      component: () => import('@/views/parent/Index'),
      meta: { requiresAuth: true },
      children: [
        {
          name: 'Parent Home',
          path: '',
          component: () => import('@/views/parent/Home'),
          meta: { requiresAuth: true }
        },
        /* {
          name: 'User Settings',
          path: 'settings',
          component: () => import('@/views/user/Settings'),
          meta: { requiresAuth: true }
        }, */
      ],
    },
    {
      path: '/school',
      component: () => import('@/views/school/Index'),
      meta: { requiresAuth: true },
      children: [
        {
          name: 'School Home',
          path: '',
          component: () => import('@/views/school/Home'),
          meta: { requiresAuth: true }
        },
        /* {
          name: 'User Settings',
          path: 'settings',
          component: () => import('@/views/user/Settings'),
          meta: { requiresAuth: true }
        }, */
      ],
    },
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      meta: { requiresAuth: true },
      children: [
        // Dashboard
        {
          name: 'Dashboard',
          path: '',
          component: () => import('@/views/dashboard/Dashboard'),
          meta: { requiresAuth: true }
        },
        // Pages
        {
          name: 'RTL',
          path: 'pages/rtl',
          component: () => import('@/views/dashboard/pages/Rtl'),
          meta: { requiresAuth: true }
        },
        /*{
          name: 'User Profile',
          path: 'pages/user',
          component: () => import('@/views/dashboard/pages/UserProfile'),
          meta: { requiresAuth: true }
        },*/
        {
          name: 'Timeline',
          path: 'pages/timeline',
          component: () => import('@/views/dashboard/pages/Timeline'),
          meta: { requiresAuth: true }
        },
        // Components
        {
          name: 'Buttons',
          path: 'components/buttons',
          component: () => import('@/views/dashboard/component/Buttons'),
          meta: { requiresAuth: true }
        },
        {
          name: 'Grid System',
          path: 'components/grid-system',
          component: () => import('@/views/dashboard/component/Grid'),
          meta: { requiresAuth: true }
        },
        {
          name: 'Tabs',
          path: 'components/tabs',
          component: () => import('@/views/dashboard/component/Tabs'),
          meta: { requiresAuth: true }
        },
        {
          name: 'Notifications',
          path: 'components/notifications',
          component: () => import('@/views/dashboard/component/Notifications'),
          meta: { requiresAuth: true }
        },
        {
          name: 'Icons',
          path: 'components/icons',
          component: () => import('@/views/dashboard/component/Icons'),
          meta: { requiresAuth: true }
        },
        {
          name: 'Typography',
          path: 'components/typography',
          component: () => import('@/views/dashboard/component/Typography'),
          meta: { requiresAuth: true }
        },
        // Forms
        {
          name: 'Regular Forms',
          path: 'forms/regular',
          component: () => import('@/views/dashboard/forms/RegularForms'),
          meta: { requiresAuth: true }
        },
        {
          name: 'Extended Forms',
          path: 'forms/extended',
          component: () => import('@/views/dashboard/forms/ExtendedForms'),
        },
        {
          name: 'Validation Forms',
          path: 'forms/validation',
          component: () => import('@/views/dashboard/forms/ValidationForms'),
          meta: { requiresAuth: true }
        },
        {
          name: 'Wizard',
          path: 'forms/wizard',
          component: () => import('@/views/dashboard/forms/Wizard'),
          meta: { requiresAuth: true }
        },
        // Tables
        {
          name: 'Regular Tables',
          path: 'tables/regular-tables',
          component: () => import('@/views/dashboard/tables/RegularTables'),
          meta: { requiresAuth: true }
        },
        {
          name: 'Extended Tables',
          path: 'tables/extended-tables',
          component: () => import('@/views/dashboard/tables/ExtendedTables'),
          meta: { requiresAuth: true }
        },
        {
          name: 'Data Tabels',
          path: 'tables/data-tables',
          component: () => import('@/views/dashboard/tables/DataTables'),
          meta: { requiresAuth: true }
        },
        // Maps
        {
          name: 'Google Maps',
          path: 'maps/google-maps',
          component: () => import('@/views/dashboard/maps/GoogleMaps'),
          meta: { requiresAuth: true }
        },
        {
          name: 'Full Screen Map',
          path: 'maps/full-screen-map',
          component: () => import('@/views/dashboard/maps/FullScreenMap'),
          meta: { requiresAuth: true }
        },
        // Root level
        {
          name: 'Widgets',
          path: 'widgets',
          component: () => import('@/views/dashboard/Widgets'),
          meta: { requiresAuth: true }
        },
        {
          name: 'Charts',
          path: 'charts',
          component: () => import('@/views/dashboard/Charts'),
          meta: { requiresAuth: true }
        },
        {
          name: 'Calendar',
          path: 'calendar',
          component: () => import('@/views/dashboard/Calendar'),
          meta: { requiresAuth: true }
        },
      ],
    },
    {
      path: '*',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: '404 Error',
          path: '',
          component: () => import('@/views/pages/Error'),
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters['authenticationService/user']) {
      store.dispatch('authenticationService/signOut');
      next({
        path: '/pages/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
});


export default router;